import { render, staticRenderFns } from "./NsSelect.vue?vue&type=template&id=4d3d5f92&scoped=true&"
import script from "./NsSelect.vue?vue&type=script&lang=js&"
export * from "./NsSelect.vue?vue&type=script&lang=js&"
import style0 from "./NsSelect.vue?vue&type=style&index=0&id=4d3d5f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3d5f92",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NsIcon: require('/usr/app/src/components/ns/NsIcon.vue').default})
